var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[(_vm.reload)?_c(_vm.isName,{ref:_vm.id,tag:"component",style:(_vm.styleChartName),attrs:{"dur":_vm.dur,"backgroundColor":_vm.backgroundColor,"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.dataChart.value)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }